export const API = process.env.REACT_APP_API_URL;
// export const API = "/api";

